import { createTheme } from '@mui/material/styles';
import i18n from "../locale/i18n.ts";
import { Direction, PaletteMode } from "@mui/material";
import palettes from "./colors.json";

export default function useProjectTheme(theme: PaletteMode) {
    return createTheme({
        direction: i18n.t("_dir") as Direction,
        palette: {
            mode: theme,
            ...palettes[theme]
        },
        typography: {
            fontFamily: "IRANYekanXFaNum",
            fontSize: 12
        },
        breakpoints: {
            values: {
                xs: 0,
                sm: 640,
                md: 768,
                lg: 1024,
                xl: 1280
            },
        },
        components: {
            MuiToggleButtonGroup: {
                styleOverrides: {
                    root: ({ theme }) => {
                        return {
                            borderRadius: 4,
                            borderColor: theme.palette.grey[400],
                            borderWidth: "1px",

                        }
                    }
                }
            },
            MuiToggleButton: {
                styleOverrides: {
                    root: ({ theme, ownerState }) => {
                        let palette = ownerState.color;
                        if (palette === 'standard' || palette === undefined) {
                            palette = 'primary'
                        }
                        let padding = "8px 40px";
                        switch (ownerState.size) {
                            case 'small':
                                padding = "8px";
                                break;
                        }
                        return {
                            "&.Mui-selected": {
                                backgroundColor: theme.palette[palette].main,
                                color: theme.palette[palette].contrastText,
                            },
                            flexGrow: 1,
                            flexBasis: 0,
                            padding,
                            borderRadius: "4px !important",
                            margin: "4px",
                            color: theme.palette.text.primary,
                            borderColor: "transparent",
                            backgroundColor: theme.palette.background.paper,
                        }
                    }
                }
            }
        }
    });
}

